<script>
import {Pie} from 'vue-chartjs';

export default {
    name: 'Grafica-nfpa',
    extends: Pie,
    props: ['conNfpa', 'sinNfpa', 'productos', 'cambia'],
    watch: {

        cambia(val) {
            this.getNfpa();
        }
    },

    methods: {
        getNfpa() {
            let porc_con_Nfpa = ((100 * this.conNfpa) / this.productos);
            let porc_sin_Nfpa = ((100 * this.sinNfpa) / this.productos);
            porc_con_Nfpa = porc_con_Nfpa.toFixed(2);
            porc_sin_Nfpa = porc_sin_Nfpa.toFixed(2);

            this.renderChart({
                labels: [porc_con_Nfpa + '% Si', porc_sin_Nfpa + '% No'],
                datasets: [
                    {
                        backgroundColor: [
                            '#04B404',
                            '#DF0101'
                        ],
                        data: [porc_con_Nfpa, porc_sin_Nfpa]
                    }
                ]
            }, {responsive: true, maintainAspectRatio: true});
        }
    }
};
</script>
